import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-action-column-molecule',
  templateUrl: './action-column-molecule.component.html',
  styleUrls: ['./action-column-molecule.component.scss']
})
export class ActionColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
  @Input() dynamicNormForm: FormGroup;
  @Output() dataEmitForDynamicNormReview = new EventEmitter<{}>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  action(actionType, controlId) {
    if (actionType === "update") {
      this.dataEmitForDynamicNormReview.emit({
        status: "MODIFIED",
        id: controlId,
        newNormValue: this.dynamicNormForm.get(controlId).value,
      });
    } else {
      this.dataEmitForDynamicNormReview.emit({
        status: actionType,
        id: controlId,
      });
    }
  }
  onEdit(id: any, event: MouseEvent) {
    this.edit.emit({ id, event });
  }

  onDelete(id: any, event: MouseEvent) {
    this.delete.emit({ id, event });
  }
}
